var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.canShowWaveform)?_c('audio-block-waveform',{attrs:{"audioUrl":_vm.selectedBlock.data.audio.url}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }